const LOAD_STATES = {
  LOADED: 'LOADED',
  LOADING: 'LOADING',
  ERROR: 'ERROR'
};

const ANCHOR = {
  HOME: {
    pl: '/',
    en: '/'
  },
  COMPANIES: {
    pl: '/nasze-spolki',
    en: '/companies'
  },
  MISSIONANDVISION: {
    pl: '/misja-i-wizja',
    en: '/mission-and-vision'
  },
  TEAMOFEXPERTS: {
    pl: '/zespol-ekspertow',
    en: '/team-of-experts'
  },
  MEDIAABOUTUS: {
    pl: '/media-o-nas',
    en: '/media-about-us'
  },
  CSR: {
    pl: '/csr',
    en: '/csr'
  },
  STRATEGY: {
    pl: '/strategia',
    en: '/strategy'
  },
  SYNERGY: {
    pl: '/synergia',
    en: '/synergy'
  },
  CASESTUDIES: {
    pl: '/case-studies',
    en: '/case-studies'
  },
  NEWS: {
    pl: '/aktualnosci',
    en: '/news'
  },
  WHISTLEBLOWING: {
    pl: '/zglaszanie-nieprawidlowosci',
    en: '/whistleblowing'
  },
  PRESSROOM: {
    pl: '/press-room',
    en: '/press-room'
  },
  CURRENT_REPORTS: {
    pl: '/raporty-biezace',
    en: '/current-reports'
  },
  JOBOFFERS: {
    pl: '/oferty-pracy',
    en: '/job-offers'
  },
  CONTACT: {
    pl: '/kontakt',
    en: '/contact'
  },
  HISTORY: {
    pl: '/historia',
    en: '/history'
  },
  AUTHORITIES: {
    pl: '/wladze',
    en: '/authorities'
  },
  FINANCIALRESULTS: {
    pl: '/wyniki',
    en: '/financial-results'
  },
  REPORTS: {
    pl: '/raporty',
    en: '/reports'
  },
  PRESENTATIONS: {
    pl: '/prezentacje-inwestorskie',
    en: '/investor-presentations'
  },
  CORPORATEGOVERNANCE: {
    pl: '/lad-korporacyjny',
    en: '/corporate-goverance'
  },
  ISSUE_OF_SHARES: {
    pl: '/emisja-akcji',
    en: '/issue-of-shares'
  },
  TERMS_OF_USE: {
    pl: '/regulamin',
    en: '/terms-of-use'
  },
  FOR_INVESTORS: {
    pl: '/relacje-inwestorskie',
    en: '/for-investors'
  },
  SHAREHOLDERS: {
    pl: '/akcjonariat',
    en: '/shareholders'
  },
  INFO_ABOUT_COMPANY: {
    pl: '/informacje-o-nas',
    en: '/info-about-us'
  },
  CALENDARIUM: {
    pl: '/kalendarium',
    en: '/calendarium'
  },
  PLANNED_EVENTS: {
    pl: '/planowane-wydarzenia',
    en: '/planned-events'
  },
  GENERAL_MEETINGS: {
    pl: '/walne-zgromadzenia',
    en: '/general-meetings'
  },
  RODO_POLICY: {
    pl: '/dane-osobowe',
    en: '/personal-data'
  },
  ZSZ_POLICY: {
    pl: '/polityka-zsz',
    en: '/ims-policy'
  },
  ANNOUNCEMENT: {
    pl: '/komunikat',
    en: '/announcement'
  }
};

const FOR_INVESTORS_SIDE_MENU = [
  {
    title: {
      pl: 'Raporty okresowe',
      en: 'Periodic reports'
    },
    hash: '/raporty',
    duplicate: false
  },
  {
    title: {
      pl: 'Raporty bieżące',
      en: 'Current reports'
    },
    hash: '/raporty-biezace',
    duplicate: false
  },
  {
    title: {
      pl: 'Wyniki finansowe',
      en: 'Financial results'
    },
    hash: '/wyniki',
    duplicate: true
  },
  {
    title: {
      pl: 'Akcjonariat spólki',
      en: 'Shareholders of the company'
    },
    hash: '/akcjonariat',
    duplicate: false
  },
  {
    title: {
      pl: 'Walne zgromadzenia',
      en: 'General meetings'
    },
    hash: '/walne-zgromadzenia',
    duplicate: false
  },
  {
    title: {
      pl: 'Strategia',
      en: 'Strategy'
    },
    hash: '/strategia',
    duplicate: true
  },
  {
    title: {
      pl: 'Wizja i misja',
      en: 'Vision and mission'
    },
    hash: '/misja-i-wizja',
    duplicate: true
  },
  {
    title: {
      pl: 'Władze',
      en: 'Authorities'
    },
    hash: '/wladze',
    duplicate: true
  },
  {
    title: {
      pl: 'Media o spółce',
      en: 'Media about the company'
    },
    hash: '/media-o-nas',
    duplicate: true
  },
  {
    title: {
      pl: 'CSR',
      en: 'CSR'
    },
    hash: '/csr',
    duplicate: true
  },
  {
    title: {
      pl: 'Ład Korporacyjny',
      en: 'Corporate governance'
    },
    hash: '/lad-korporacyjny',
    duplicate: true
  },
  {
    title: {
      pl: 'Historia',
      en: 'History'
    },
    hash: '/historia',
    duplicate: true
  },
  {
    title: {
      pl: 'Rynek i działalność spółki',
      en: 'Info about company'
    },
    hash: '/informacje-o-nas',
    duplicate: false
  },
  {
    title: {
      pl: 'Wydarzenia',
      en: 'Events'
    },
    hash: '/planowane-wydarzenia',
    duplicate: false
  },
  {
    title: {
      pl: 'Prezentacje inwestorskie',
      en: 'Investor presentations'
    },
    hash: '/prezentacje-inwestorskie',
    duplicate: false
  }
].filter(({ hash, href }) => hash || href);

const CONTACT = {
  GENERAL: 'hello@tenderhut.com',
  EVENT: 'event@softwarehut.com',
  JOIN_US: 'hello@tenderhut.com'
};

const SOCIAL = {
  LINKEDIN: 'https://www.linkedin.com/company/tenderhut',
  FACEBOOK: 'https://www.facebook.com/tenderhut'
};

const EXTERNAL_LINK = {
  NEW_CONNECT: 'https://newconnect.pl/spolka?isin=PLTNDRH00012',
  GPW: 'https://www.gpw.pl/spolka?isin=PLTNDRH00012',
  SATISFACTION_SURVEY: 'https://forms.office.com/r/L6utXsAzkr',
  CAREER: 'https://tenderhut.elevato.net/pl/aplikacje-spontaniczne,ja,61'
};

const GOOGLE = {
  TAG_MANAGER_ID: 'GTM-5SGZDKB',
  MAP_API_KEY: 'AIzaSyCLK9dYoXLg3KHn-Nb2r-dhw3rj-yCJvYI'
};

const REPORT = {
  BASE_URL: process.env.REACT_APP_REPORT_DOMAIN
};

const COMPANIES_COLORS = {
  TENDERHUT: '#5252FF',
  SOFTWAREHUT: '#E44510',
  EXTRAHUT: '#2D2D2D',
  LEGALHUT: '#6450D6',
  PROTECTHUT: '#ED3135',
  SOLUTION4LABS: '#4DC9F4'
};

const COMPANIES = {
  TENDERHUT: 'tenderhut',
  SOFTWAREHUT: 'softwarehut',
  EXTRAHUT: 'extrahut',
  LEGALHUT: 'legalhut',
  PROTECTHUT: 'protecthut',
  SOLUTION4LABS: 'solution4labs'
};

const COMPANIES_WITH_PROJECTS = [COMPANIES.EXTRAHUT];

const FORM_SUCCESS_MESSAGE_TIMEOUT = 2000;

const LARGE_NUMBER_OF_ITEMS = 6;

const SURVEY_ANCHOR = {
  SATISFACTION_SURVEY: '/satisfaction-survey',
  INFORMATION_CLAUSE: '/information-clause'
};

// Do not switch to ES6 export - sitemap-builder script needs to import this constants in ES5 syntax
module.exports = {
  LOAD_STATES,
  ANCHOR,
  CONTACT,
  SOCIAL,
  GOOGLE,
  REPORT,
  COMPANIES_COLORS,
  COMPANIES,
  COMPANIES_WITH_PROJECTS,
  FORM_SUCCESS_MESSAGE_TIMEOUT,
  LARGE_NUMBER_OF_ITEMS,
  FOR_INVESTORS_SIDE_MENU,
  EXTERNAL_LINK,
  SURVEY_ANCHOR
};



// WEBPACK FOOTER //
// ./src/common/consts/common.js